export default __webpack_public_path__ + "static/media/darkbanner.8d8ed3a0.3885f548.jpg";